import t from 'tcomb';
import Validation_Monad from './Validation_Monad';

const Date_Schema = t.struct({
  required: t.maybe(t.Bool)
}, 'Date_Schema');


/*
function Date_Schema(required) {
  assert(Maybe(Bool).is(required));
  this.type = 'date';
  this.required = required;
  return freeze(this);
}

Date_Schema.is = function(x) {
  return x instanceof Date_Schema;
};

Date_Schema.of = function(x) {
  assert(Obj.is(x));
  return new Date_Schema(
    Maybe(Bool).of(x.required)
  );
};
*/

Date_Schema.prototype.validate = function(a) {
  var actions = [];
  actions.push(Validation_Monad.date(!!this.required));
  return Validation_Monad.pipe(a, actions);
};

export default Date_Schema;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Date_Schema.js
 **/